/**
 * I4go
 *
 * @author markov
 * @returns {I4go}
 */
(function(global, factory) {
    if (typeof module === 'object' && typeof module.exports === 'object') {
        module.exports = factory(global);
    }
})(typeof window !== 'undefined' ? window : this, function(window) {
    function I4go(config) {
        this.config = config ? config : {};
    }

I4go.prototype.helperChangeParser = null;

/**
 * Get authorize client
 */
I4go.prototype.getAuthorizeClientResponse = function(callback) {
    jQuery.ajax({
        url: '/i4go/authorize-client',
        type: 'GET',
        dataType: 'json',
        data: this.config,
        success: function(data) {
            callback(data);
        },
        error: function() {
            callback();
        }
    });
};

/**
 * Add token store
 */
I4go.prototype.addTokenstore = function(params, callback) {
    this.getAuthorizeClientResponse(function(data) {
        if (!data) {
            callback({
                i4go_response: 'FAILURE',
                i4go_responsetext: 'ERROR'
            });
            return false;
        }
        window.parseResponse = function(response) {
            callback(response);
        };
        params.i4go_accessblock = data.i4go_accessblock;
        params.fuseaction = 'api.jsonpPostCardEntry';
        params.i4go_p2pedevicetype = '01';
        jQuery.ajax({
            url: data.i4go_server,
            type: 'POST',
            dataType: 'jsonp',
            data: params,
            timeout: 10000,
            error: function(data) {
                if (data.statusText === 'success') {
                    return true;
                }
                callback({
                    i4go_response: 'FAILURE',
                    i4go_responsetext: 'ERROR: Timeout.'
                });
            }
        });
    });
};

/**
 * Get street address from form
 *
 * @param {Array} formParamsArray form params
 * @returns {String}
 */
I4go.prototype.getStreetAddressFromForm = function(formParamsArray) {
    var streetAddress = '';
    var params = {
        state: '',
        city: '',
        address1: '',
        address2: ''
    };
    var associationKeys = {
        'bill_street_address': 'address1',
        'street_address': 'address1',
        'street_address2': 'address2'
    };
    for (var i in formParamsArray) {
        var item = formParamsArray[i];
        if (associationKeys[item.name]) {
            params[associationKeys[item.name]] = item.value;
        }
    }
    for (var i in params) {
        if (!params[i].length) {
            continue;
        }
        if (streetAddress.length) {
            streetAddress += ' ';
        }
        streetAddress += params[i];
    }
    return streetAddress;
};

I4go.prototype.getCardData = function(formParamsArray) {
    var cardData = {};
    var associationKeys = {
        'cc_number' : 'i4go_cardnumber',
        'card_number' : 'i4go_cardnumber',

        'cc_name' : 'i4go_cardholdername',
        'card_name' : 'i4go_cardholdername',

        'cc_date[month]' : 'i4go_expirationmonth',
        'cc_date[year]' : 'i4go_expirationyear',

        'month' : 'i4go_expirationmonth',
        'year' : 'i4go_expirationyear',

        'bill_cvv' : 'i4go_cvv2Code',
        'cvc' : 'i4go_cvv2Code',
        'security_code' : 'i4go_cvv2Code',

        'bill_zip' : 'i4go_postalcode',
        'zip' : 'i4go_postalcode',
        'post_code' : 'i4go_postalcode',

        // Form user/initial
        'cc_date[m]' : 'i4go_expirationmonth',
        'cc_date[Y]' : 'i4go_expirationyear',

        i4go_p2peblock: 'i4go_p2peblock',
        i4go_account_type: 'i4go_account_type'
    };

    jQuery.each(formParamsArray, function(key, item) {
        if (associationKeys[item.name]) {
            cardData[associationKeys[item.name]] = item.value;
        }
    });

    return cardData;
};

/**
 * Validate data card
 *
 * @param cardData
 */
I4go.prototype.validate = function(cardData, success, error) {
    if (!this.useKeySecureDevice) {
        if (cardData.i4go_cardnumber && !cardData.i4go_cvv2Code) {
            error('Please enter credit card CVV');
            return;
        }
    }
    if (cardData.i4go_cardnumber && cardData.i4go_cardnumber.indexOf('*') !== -1) {
        error('For security purposes all changes require the reentry of the credit card number.');
        return;
    }
    success();
};

I4go.prototype.useKeySecureDevice = false;
I4go.prototype.useExistingCard = false;

/**
 * Get First Digit By Credit Type
 *
 * @param creditType Credit Type
 */
I4go.prototype.getFirstDigitByCreditType = function(creditType) {
    var types = {
        AX: {
            name: 'American Express',
            firstDigit: '3'
        },
        MC: {
            name: 'MasterCard',
            firstDigit: '5'
        },
        NS: {
            name: 'Discover/Novus',
            firstDigit: '6'
        },
        VS: {
            name: 'Visa',
            firstDigit: '4'
        }
    };
    if (!types[creditType]) {
        return null;
    }
    return types[creditType].firstDigit;
};

I4go.prototype.dataChange = function(formParamsArray, successCallback, errorCallback) {
    var self = this;
    var shift4Active = false;
    var isI4goIframe = false;
    for (var i in formParamsArray) {
        var item = formParamsArray[i];
        if (item.name === 'shift4_active' && item.value == 1) {
            shift4Active = true;
        }
        if (item.name === 'i4go_iframe' && item.value == 1) {
            isI4goIframe = true;
        }
        if (item.name == 'useKeySecureDevice') {
            this.useKeySecureDevice = true;
        }

        if(item.name === 'existingCard' && item.value === '1') {
            successCallback();
            return;
        }

        if(item.name === 'isBankAccount' && item.value === '1') {
            successCallback();
            return;
        }
    }
    for (var i in formParamsArray) {
        var item = formParamsArray[i];
        if (item.name === 'shift4_disabled_on_show_resources' && item.value == 1) {
            shift4Active = false;
        }
    }
    if (!shift4Active || isI4goIframe) {
        successCallback();
        return;
    }
    if(this.useExistingCard) {
        successCallback();
        return;
    }
    var cardData = {};
    cardData = this.getCardData(formParamsArray);

    var streetAddress = this.getStreetAddressFromForm(formParamsArray);
    if (streetAddress.length) {
        cardData.i4go_streetaddress = streetAddress;
    }
    if (this.helperChangeParser && !this.helperChangeParser.isChanged()) {
        successCallback();
        return;
    }

    this.validate(
        cardData,
        function() {
            if (!cardData.i4go_cardnumber && !cardData.i4go_p2peblock) {
                successCallback();
                return;
            }

            if (cardData.i4go_p2peblock && cardData.i4go_account_type) {
                self.config['accountType'] = cardData.i4go_account_type;
            }

            self.addTokenstore(cardData, function(data) {
                if (data && data.i4go_response === 'FAILURE') {
                    alert(data.i4go_responsetext);
                    errorCallback();
                    return;
                }

                data.expiration_date = data.i4go_expirationyear + '-' + data.i4go_expirationmonth + '-01';

                var firstDigit = self.getFirstDigitByCreditType(data.i4go_cardtype);
                var ccNumberEscape = firstDigit + Array(12).join('*') + data.i4go_uniqueid.slice(0, 4);
                data.cc_number = ccNumberEscape;

                successCallback(data);
            });
        },
        function(error) {
            alert(error);
            errorCallback();
        }
    );
};

/**
 * Set I4go Params To Form
 *
 * @param $form
 */
I4go.prototype.setI4goParamsToForm = function($form, data) {
    var fieldNames = [
        {
            responseName: 'i4go_uniqueid',
            inputName: 'cc_merchant_unique_id'
        },
        {
            responseName: 'expiration_date',
            inputName: 'cc_date'
        }
    ];

    jQuery.each(fieldNames, function(key, item) {
        var $item = $form.find('[name="' + item.inputName + '"]');
        if ($item.length) {
            $item.val(data[item.responseName]);
        } else {
            $form.append(
                '<input type="hidden" name="' + item.inputName + '" value="'
                + data[item.responseName] + '">'
            );
        }
    });

    $form.find('[name=cc_number],[name="ccInfo[ccNumber]"],[name=card_number]').val(data.cc_number);
};

/**
 * Change form for i4go
 */
I4go.prototype.formChange = function(form, resultCallback) {
    var self = this;
    jQuery('body').caLoadingSplash();
    jQuery('body').caLoadingSplash('show');
    function callback(result) {
        jQuery('body').caLoadingSplash('hide');
        resultCallback(result);
    }

    var formParamsArray = [];
    if (form) {
        var $form = jQuery(form);
        formParamsArray = helperForm.serializeArray($form);
    }

    this.dataChange(
        formParamsArray,
        function(dataChanged) {
            if (!dataChanged) {
                callback(true);
                return;
            }
            var $form = jQuery(form);
            self.setI4goParamsToForm($form, dataChanged);
            callback(true);
        },
        function() {
            callback(false);
        }
    );
};

window.I4go = I4go;
return I4go;
});